import { render, staticRenderFns } from "./SliderTicks.vue?vue&type=template&id=9cc3c868&"
import script from "./SliderTicks.vue?vue&type=script&lang=js&"
export * from "./SliderTicks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports